import FeatureTypeList from "@/components/feature/FeatureTypCardGridView";
import type { LayoutContext } from "@/lib/models";
import { type Code } from "@/services/CodeService";
import { useEffect } from "react";
import { useOutletContext } from "react-router";

export interface ActionListItem {
  id: string;
  name: string;
  priority: Code | undefined;
  status: Code | undefined;
  startDate: string | null;
  endDate: string | null;
}

const SiteCourseFeatureTypeList: React.FC = () => {
  const { setPageName } = useOutletContext<LayoutContext>();

  useEffect(() => {
    setPageName('Tasks List'); // Set the page name when the component mounts
    return () => setPageName('Tasks List'); // Optional: Reset on unmount
  }, [setPageName]);

    return(
    <div className="container mx-auto p-4">
        <FeatureTypeList subType="Course" />
    </div>        
        
  );
};

export default SiteCourseFeatureTypeList;